import { Container, Grid, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";

import DriverRequestDetails from "@/components/Driver/DriverRequestDetails";
import { ConfirmationDialogButton } from "@/components/Driver/DriverRequestDetails/confirmation-dialog-button";
import { useEnableDriverMutation, useGetDriverByIdQuery } from "@/libs/generated/hooks";
import {
  DRIVER_ACTIONS,
  ERROR_MESSAGES,
  NAVIGATION_ROUTES,
  SUCCESS_MESSAGES,
  TOAST_CONFIG,
} from "@/utils/constants/driver-actions";

function BannedDriverDetails() {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  if (!id) throw new Error("no driver id in params");

  const {
    data,
    error,
    isPending: loading,
  } = useGetDriverByIdQuery({
    GetByIdInput: {
      id: Number(id),
    },
  });

  const enableDriver = useEnableDriverMutation({
    onSuccess: () => {
      toast.success(t(SUCCESS_MESSAGES.ENABLE), TOAST_CONFIG);
      navigate(NAVIGATION_ROUTES.DISABLED_DRIVERS);
    },
    onError: (err: any) => {
      toast.error(err.message || t(ERROR_MESSAGES.GENERIC), TOAST_CONFIG);
    },
  });

  const isEnablingDriver = enableDriver.isPending;

  if (loading) return <p>{t("common.loading")}</p>;
  if (error) {
    return <p>{t("common.error.generic")}</p>;
  }
  if (!data?.getDriverById) {
    return <p>{t("common.no-data")}</p>;
  }
  const driverData = data.getDriverById;
  return (
    <Container sx={{ py: 4 }} maxWidth="xl">
      <Grid container spacing={2}>
        <DriverRequestDetails
          driverData={driverData}
          actions={
            <ConfirmationDialogButton
              buttonText={DRIVER_ACTIONS.ENABLE.buttonText}
              title={DRIVER_ACTIONS.ENABLE.title}
              buttonColor={theme.palette.success.main}
              description={DRIVER_ACTIONS.ENABLE.confirmation}
              icon={DRIVER_ACTIONS.ENABLE.icon}
              actionIsLoading={isEnablingDriver}
              onConfirm={() => {
                enableDriver.mutate({
                  input: { email: driverData.email },
                });
              }}
            />
          }
        />
      </Grid>
    </Container>
  );
}

export default BannedDriverDetails;
